var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "txpair-head-wrapper" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("token", { staticClass: "token-wrapper" }),
          _vm._v(" "),
          _c("div", { staticClass: "else-wrapper" }, [
            _c("div", { staticClass: "latest-price" }, [
              _c("div", { staticClass: "token-title" }, [
                _vm._v(_vm._s(_vm.$t("trade.head.latestPrice")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-content" }, [
                _c(
                  "span",
                  {
                    class: {
                      up: +_vm.upDownPrev > 0,
                      down: +_vm.upDownPrev < 0
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.activeTxPair && _vm.activeTxPair.closePrice
                            ? _vm.formatNum(
                                _vm.activeTxPair.closePrice,
                                _vm.activeTxPair.pricePrecision
                              )
                            : "--"
                        ) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.realPrice) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "updown item-left" }, [
              _c("div", { staticClass: "token-title" }, [
                _vm._v(_vm._s(_vm.$t("trade.head.updown")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "token-content",
                  class: {
                    up: +_vm.upDown > 0,
                    down: +_vm.upDown < 0
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.upDownIcon +
                        (!!_vm.activeTxPair
                          ? _vm.formatNum(
                              _vm.upDown,
                              _vm.activeTxPair.pricePrecision
                            )
                          : _vm.upDown)
                    ) +
                      "\n                    " +
                      _vm._s(
                        _vm.activeTxPair && _vm.activeTxPair.upDownPercent
                          ? _vm.upDownIcon + _vm.activeTxPair.upDownPercent
                          : "--"
                      ) +
                      "\n                "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "high-price item-left" }, [
              _c("div", { staticClass: "token-title" }, [
                _vm._v(_vm._s(_vm.$t("trade.head.highPrice")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-content" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.activeTxPair && _vm.activeTxPair.highPrice
                        ? _vm.activeTxPair.highPrice
                        : "--"
                    ) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "low-price item-left" }, [
              _c("div", { staticClass: "token-title" }, [
                _vm._v(_vm._s(_vm.$t("trade.head.lowPrice")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-content" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.activeTxPair && _vm.activeTxPair.lowPrice
                        ? _vm.activeTxPair.lowPrice
                        : "--"
                    ) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "quantity item-left" }, [
              _c("div", { staticClass: "token-title" }, [
                _vm._v(_vm._s(_vm.$t("trade.head.quantity")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-content" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.activeTxPair && _vm.activeTxPair.amount
                        ? _vm.formatNum(_vm.activeTxPair.amount, 3) +
                            " " +
                            _vm.activeTxPair.originQuoteTokenSymbol
                        : "--"
                    ) +
                    "\n                "
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "else-point __pointer",
        on: { click: _vm.showTxPair }
      }),
      _vm._v(" "),
      _c("tx-pair", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowTxPair,
            expression: "isShowTxPair"
          }
        ],
        attrs: { close: _vm.hideTxPair }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }